import React from 'react';
import cn from 'classnames';
import ContactAvatar, {
  AngledContactGroup,
  ImportContactAvatarGroup,
} from '@components/ContactAvatar';
import styles from './ActivityListItemAvatars.module.scss';
import { Logo } from '@components/Icons';
import Contact from '@models/Contact';
import { useTheme } from '@hooks/use-theme';
import { ImportSource } from '@models/Activity';
import { useThemedIconForSource } from '@support/hooks/use-themed-icon-for-source';
import { ContactInfo } from '@app/types';
import Occasion from '@support/Occasion';
import BadgeIcon, { BadgeType } from '../BadgeIcon/BadgeIcon';
import { useSelector } from 'react-redux';
import { selectContact } from '@actions/contacts';

export const BadgedAvatar = ({
  contact,
  badgeType,
  date,
}: {
  contact: Contact;
  badgeType: BadgeType | ImportSource;
  date?: Occasion;
}) => {
  const contactInStore = useSelector(selectContact(contact.id, null));
  const importIconSrc = useThemedIconForSource({ type: badgeType } as ContactInfo);
  let icon = <BadgeIcon type={badgeType as BadgeType} date={date} />;

  if (importIconSrc) {
    icon = (
      <div className={styles.sourceIcon} style={{ backgroundImage: `url(${importIconSrc})` }} />
    );
  }

  return (
    <div className={cn(styles.avatarContainer, 'badgedAvatar')}>
      <ContactAvatar
        contact={contactInStore || contact}
        className={styles.avatar}
        grayscale={badgeType === 'memorial'}
      />
      {icon}
    </div>
  );
};

export const ImportAvatars = ({
  contacts,
  importSource,
  importTotal,
}: {
  contacts: Contact[];
  importSource: ImportSource;
  importTotal: number;
}) => {
  const iconSrc = useThemedIconForSource({ type: importSource } as ContactInfo);
  return (
    <div className={styles.importAvatarIcons}>
      <ImportContactAvatarGroup importTotal={importTotal} contacts={contacts} />
      <div className={styles.sourceIcon} style={{ backgroundImage: `url(${iconSrc})` }} />
    </div>
  );
};

export const ClayBadge = () => {
  const [_, themeFamily] = useTheme();

  return (
    <span className={cn(styles.clayIcon, styles[themeFamily])}>
      <Logo width="24" height="13.3" preserveAspectRatio="xMidYMin meet" />
    </span>
  );
};

export const BadgedAvatarGroup = ({
  contacts,
  badgeType,
}: {
  contacts: Contact[];
  badgeType: BadgeType;
}) => (
  <div className={styles.avatarContainer}>
    <AngledContactGroup contacts={contacts} />
    <BadgeIcon type={badgeType} />
  </div>
);
